import React, {useState, useEffect} from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import agent from "../../../../../agent";
const short = require("short-uuid");

const Invoice = () => {
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingIssued, setBookingIssued] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrData, setQrData] = useState<any>();
  const [uri, setUri] = useState("");
  const [preAuthCode, setPreAuthCode] = useState("");
  const [qrCode, setQrCode] = useState<JSX.Element>();

  useEffect(() => {
  }, []);

  const renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  const handleButtonClick = () => {
    setShowBookingForm(true);
  };

  const handleFormSubmit = () => {
    setShowBookingForm(false);
    setShowBookingDetails(true);
  };

  const generateNewQRCodeForInsurance = async () => {
    const shortUuid = short.generate();
    let today = new Date();

    const uriData: IOID4VCIClientCreateOfferUriResponse =
      await agent.oid4vciClientCreateOfferUri({
        grants: {
          "urn:ietf:params:oauth:grant-type:pre-authorized_code": {
            "pre-authorized_code": shortUuid,
            user_pin_required: false,
          },
        },
        credentialDataSupplierInput: {
          amount: "145",
          currency: "EUR",
          merchantName: "Luxury Hotel",
          merchantAddress: "Paradise Street 7, 8606 Shangri La, Utopia",
          invoiceDate: new Date().toLocaleDateString(),
          subjectPerson: "Bogdan Mocanu",
          invoiceDetails: "Hotel Expenses: Minibar - 5 EUR, Restaurant - 90 EUR, SPA - 50 EUR. Total - 145 EUR",
        },
        credentials: ["Invoice"],
      });



    const qrState = {
      uri: uriData.uri,
      preAuthCode: shortUuid,
      qrData: {
        object: uriData.uri,
        type: QRType.URI,
        id: "567",
      },
    };
    setUri(uriData.uri);
    setPreAuthCode(shortUuid);
    let dataQR: any= {
      object: uriData.uri,
      type: QRType.URI,
      id: "567",
    };
    setQrData(dataQR);

    agent
      .qrURIElement({
        data: dataQR,
        renderingProps: renderingProps,
      })
      .then((qrCode: JSX.Element) => {
        setQrCode(qrCode);
      });

    const intervalId = setInterval(() => {
      agent
        .oid4vciClientGetIssueStatus({ id: shortUuid! })
        .then((status: IssueStatusResponse) => {
          if (status.status === IssueStatus.CREDENTIAL_ISSUED) {
            clearInterval(intervalId);
            setQrCode(undefined);
            setBookingIssued(true);
          } else if (status.status === IssueStatus.ERROR) {
            // TODO: Add feedback to user
            console.error(status.error);
            clearInterval(intervalId);
          }
        })
        .catch((error: Error) => {
          clearInterval(intervalId);
          console.error(`ERROR: ${error.message}`);
        });
    }, 1000);
  }
  return (
    <Container style={{ textAlign: "center", padding: "50px" }}>
      {bookingIssued == false? (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={6} className="d-flex align-items-center">
                <div>
                  <h2>Invoice</h2>
                  <p>
                  Scan the QR code with your wallet to download your digital invoice.
                  </p>
                </div>
              </Col>
              <Col
                md={6}
                className="text-center d-flex flex-column justify-content-center align-items-center"
              >
              </Col>
            </Row>
            ) : (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={12} className="align-items-center">
                <div>
                  <h2>Thank you!</h2>
                  <p>
                   We hope you had a great experience!!
                  </p>
                </div>
              </Col>
            </Row>
            )}
    </Container>
  );
};

export default Invoice;
